import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const DigilockerCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlClientId = searchParams.get("client_id");

    // If client_id is present in query parameters, sync/update localStorage
    if (urlClientId) {
      localStorage.setItem("quickbgv_digilockerClientId", urlClientId);
    }

    // Read stored return path or default back to Aadhaar check page
    const savedReturnUrl =
      localStorage.getItem("redirectAfterDigilocker") || "/employee/aadhaarcheck";

    // Clean up temporary return URL from localStorage
    localStorage.removeItem("redirectAfterDigilocker");

    // Navigate cleanly back to the target route without appending search query params
    navigate(savedReturnUrl, { replace: true });
  }, [navigate, location]);

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h3>Processing DigiLocker Verification...</h3>
      <p>Please wait, redirecting back...</p>
    </div>
  );
};

export default DigilockerCallback;